import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex h-screen flex-col items-center justify-center px-4 text-center">
      <span className="absolute bottom-0 select-none font-heading text-[12rem] font-black leading-none text-background-100 pointer-events-none md:text-[16rem]">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-map-pin-2-line text-2xl leading-none"></i>
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          This page has not been generated
        </h1>
        <p className="mt-2 text-base text-foreground-500">
          <span className="font-mono">{location.pathname}</span>
        </p>
        <p className="mt-4 text-lg text-foreground-600">
          Tell me more about this page, so I can generate it
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-home-4-line text-base leading-none"></i>
          </span>
          Back to Home
        </Link>
      </div>
    </div>
  );
}